<template>
  <div class="policy">
    <div class="home2-title">
      政策资讯
      <a href="#/news">查看更多</a>
    </div>
    <div class="policy-box">
      <div class="policy-left">
        <div class="policy-swiper">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) of headlineNewsList"
              :key="index"
            >
              <a
                class="policy-card"
                :href="'#/newsDetail?newsId=' + item.newsId"
              >
                <img :src="item.newsPic" alt="" />
                <div class="title">
                  <p>
                    【站内新闻】<span>{{ item.newsTitle }}</span>
                  </p>
                  <span>查看详情 >></span>
                </div>
              </a>
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            <div class="swiper-button-prev nav-btn" slot="button-prev"></div>
            <div class="swiper-button-next nav-btn" slot="button-next"></div>
          </swiper>
        </div>
        <ul class="list">
          <li v-for="(item, index) of stationList" :key="index">
            <a
              :href="'#/newsDetail?newsId=' + item.newsId"
              :title="item.newsTitle"
            >
              <p>【站内新闻】{{ item.newsTitle }}</p>
              <span>{{ item.newsReleaseTime | newsTime }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="policy-right">
        <ul class="list">
          <li v-for="(item, index) of innerList" :key="index">
            <a
              :href="'#/newsDetail?newsId=' + item.newsId"
              :title="item.newsTitle"
            >
              <div class="time">
                {{ item.newsReleaseTime | ym }}
                <p>
                  {{ item.newsReleaseTime | day }}
                </p>
              </div>
              <div class="content">
                <p class="title">{{ item.newsTitle }}</p>
                <p class="detail">{{ item.newsSummary }}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { parseTime } from "@/utils/ruoyi";
import { getCmsList } from "../../../api/service.js";
import {
  getNewsSlidshow as API_getNewsSlidshow,
  getNewsInformationList as API_getNewsInformationList,
} from "@/apiCloud/news";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      pageNum: 1,
      pageSize: 4,
      generalNewsList: [],
      headlineNewsList: [], //轮播
      stationList: [], //站内
      innerList: [], //行内
      swiperOptions: {
        autoplay: true,
        pagination: {
          //   el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  created() {
    this.getNewsSlidshow();
    this.getNewsInformationList(1);
    this.getNewsInformationList(2);
  },
  methods: {
    //获取新闻资讯轮播图
    getNewsSlidshow() {
      API_getNewsSlidshow({}).then((res) => {
        if (res.code == 200) {
          this.generalNewsList = res.data.generalNewsList;
          this.headlineNewsList = res.data.headlineNewsList;
        }
      });
    },
    //根据分类获取新闻
    getNewsInformationList(type) {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        newsCategory: type, // 站内是1 行内是2
      };
      API_getNewsInformationList(data).then((res) => {
        if (res.code == 200) {
          if (type == 1) {
            this.stationList = res.rows;
          }
          if (type == 2) {
            this.innerList = res.rows;
          }
        }
      });
    },
    // 跳转新闻详情
    toDtail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          newsId: id,
        },
      });
    },
  },
  filters: {
    newsTime(val) {
      return parseTime(val, "{y}-{m}-{d}");
    },
    ym(val) {
      return parseTime(val, "{y}-{m}");
    },
    day(val) {
      return parseTime(val, "{d}");
    },
  },
};
</script>

<style lang="less"  src="./public.less" scoped></style>
<style lang="less" scoped>
.policy {
  width: 1200px;
  margin: 20px auto 0;
  padding: 0 21px;
  box-sizing: border-box;
  background: #fff;
  .home2-title {
    position: relative;
    background-image: url("../../../../static/home2.0/icon-policy.png");
    a {
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      color: #666;
      font-size: 16px;
      padding-right: 20px;
      font-weight: normal;
      background: url("../../../../static/home2.0/icon-more.png") no-repeat
        center right;
      cursor: pointer;
      &:hover {
        color: #3482ff;
      }
    }
  }

  .policy-box {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    .policy-left {
      width: 540px;
      .policy-swiper {
        .nav-btn {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.2);
          color: #fff;
          font-size: 12px;
          transition: all 0.3s;
          &:after {
            font-size: 16px;
          }
          &:hover {
            background: #2590f4;
          }
          &.swiper-button-prev {
            left: 0;
          }
          &.swiper-button-next {
            right: 0;
          }
        }
      }
      .policy-card {
        display: block;
        position: relative;
        height: 390px;
        overflow: hidden;
        img {
          display: block;
          max-height: 100%;
          margin: 0 auto;
        }
        .title {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 68px;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 20px;
          box-sizing: border-box;
          p {
            width: 400px;
            color: #fff;
            font-size: 16px;
            display: flex;
            align-items: center;
            span {
              width: 300px;
            }
          }
          & > span {
            color: #3482ff;
            font-size: 16px;
          }
        }
      }
      .list {
        margin-top: 20px;
        a {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 40px;
          color: #333;
          font-size: 16px;
          padding-left: 16px;
          transition: all 0.3s;
          &:before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -3px;
            width: 6px;
            height: 6px;
            background: #3482ff;
          }
          &:hover {
            color: #3482ff;
          }
          p {
            width: 410px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span {
            color: #999;
          }
        }
      }
    }
    .policy-right {
      width: 572px;
      .list {
        a {
          display: flex;
          border-bottom: 1px solid #efefef;
          transition: all 0.2s;
          &:hover {
            box-shadow: 0 0 10px 2px #ddd;
            .time {
              background: #3482ff;
              color: #fff;
            }
          }
          .time {
            width: 78px;
            color: #3482ff;
            font-size: 16px;
            text-align: center;
            padding-top: 35px;
            box-sizing: border-box;
            transition: all 0.2s;
            p {
              font-size: 22px;
            }
          }
          .content {
            flex: 1;
            padding: 30px 10px;
            box-sizing: border-box;
            .title {
              color: #3482ff;
              font-size: 16px;
            }
            .detail {
              width: 460px;
              color: #999;
              font-size: 14px;
              margin-top: 20px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home3.0/src/Policy.vue